import React from 'react';

function SkillBadge({ name, level }) {
  return (
    <span className={`skill-badge ${level}`}>
      {name}
    </span>
  );
}

export default SkillBadge;